import React from 'react';

const NotFound = () => {
    return (
        <div className='text-center'>
            <h1>404</h1>
            <h4>The page is not found</h4>
        </div>
    );
};

export default NotFound;